"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateReservationDto = exports.ByDraftSlotIdDto = exports.DraftIdsDto = exports.GetDraftSlotsOptions = exports.GetDraftReservationOptionsDto = exports.GetDraftReservationAddonsQueryDto = exports.DraftSlotsFilterResultDto = exports.SimpleDraftSegmentDto = exports.ByRentalProductId = exports.ByDraftReservationIdDto = exports.GetDraftReservationSlotsFiltersDto = exports.AddSegmentsDto = exports.InvoiceReservationItemsDto = exports.ChargeReservationResultDto = exports.UpdateCustomerSlotsColorsDto = exports.UpdateReservationSlotsColorsDto = exports.ReservationNotifyDto = exports.RemoveSlotsFinancialDataDto = exports.EditReservationDetailsDto = exports.EditItemsRefundMetaDto = exports.FindBySlotDto = exports.UpdateReservationStatusDto = exports.FindBySlotIdsDto = exports.DuplicateSlotDto = exports.GetFilterOptionsDto = exports.FindByReservationDto = exports.getSlotFQueryParamsDto = exports.IncludeConflictsOptionsDto = exports.FindSlotsByFacilityIdFiltersDto = exports.FindReservationsByUserIdFiltersDto = exports.ReservationTableOptionsDto = exports.FindReservationsByOrganizationIdFiltersDto = exports.BookingDto = exports.BookingData = exports.UpdateReservationPriceDto = exports.CategoryPricesDto = exports.FindSlotsQueryParamsDto = exports.SlotsFilterDto = exports.SingleReservationIncludesDto = exports.CreateReservationCartDto = exports.DraftReservationDto = exports.SimpleDraftReservationDto = exports.CreateDraftReservationDto = exports.SegmentsAddonsDto = exports.CreateSegmentsAddonsDto = exports.BaseReservationItemLineItemDataDto = exports.ReservationDto = exports.DuplicatedDetailsDto = exports.SimpleReservationDto = exports.ProductPricesDto = void 0;
exports.EditReservationItemsResultDto = exports.EditSlotsRefundMetadataDto = exports.EditSlotsFinancialDetailsDto = exports.EditItemsRefundMetadataDto = exports.ReservationItemLineDto = exports.DuplicateReservationItemsDto = exports.DuplicateReservationDto = exports.PaginatedSlotsSharedDto = exports.ProblematicProductDto = exports.CreateReservationAddonsDto = exports.ReservationAddonsDto = exports.SegmentsAddonsGroupDto = exports.UpdateDraftSlotsDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const invoice_dto_1 = require("../../invoice/dto/invoice.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const purchase_dto_1 = require("../../purchase/dto/purchase.dto");
const MAX_SLOTS_REQUEST_LIMIT = 5000;
const MONTH_OF_JANUARY = 0;
const MONTH_OF_DECEMBER = 11;
class ProductPricesDto {
}
exports.ProductPricesDto = ProductPricesDto;
class BaseReservationDto {
}
class SimpleReservationDto extends BaseReservationDto {
}
exports.SimpleReservationDto = SimpleReservationDto;
class DuplicatedDetailsDto {
}
exports.DuplicatedDetailsDto = DuplicatedDetailsDto;
class ReservationDto extends SimpleReservationDto {
}
exports.ReservationDto = ReservationDto;
class BaseReservationItemLineItemDataDto {
}
exports.BaseReservationItemLineItemDataDto = BaseReservationItemLineItemDataDto;
class SlotsLineItemDataDto extends BaseReservationItemLineItemDataDto {
}
class BaseSegmentsAddonsGroupDto {
}
class CreateSegmentsAddonsDto extends BaseSegmentsAddonsGroupDto {
}
exports.CreateSegmentsAddonsDto = CreateSegmentsAddonsDto;
class SegmentsAddonsDto extends CreateSegmentsAddonsDto {
}
exports.SegmentsAddonsDto = SegmentsAddonsDto;
class CreateDraftReservationDto extends BaseReservationDto {
}
exports.CreateDraftReservationDto = CreateDraftReservationDto;
class SimpleDraftReservationDto extends CreateDraftReservationDto {
}
exports.SimpleDraftReservationDto = SimpleDraftReservationDto;
class DraftReservationDto extends SimpleDraftReservationDto {
}
exports.DraftReservationDto = DraftReservationDto;
class CreateReservationCartDto {
}
exports.CreateReservationCartDto = CreateReservationCartDto;
class SingleReservationIncludesDto {
}
exports.SingleReservationIncludesDto = SingleReservationIncludesDto;
class SlotsFilterDto {
}
exports.SlotsFilterDto = SlotsFilterDto;
class FindSlotsQueryParamsDto extends general_dto_1.PaginationSearchQuery {
}
exports.FindSlotsQueryParamsDto = FindSlotsQueryParamsDto;
class CategoryPricesDto {
}
exports.CategoryPricesDto = CategoryPricesDto;
class UpdatePriceDto {
}
class UpdateReservationPriceDto extends UpdatePriceDto {
}
exports.UpdateReservationPriceDto = UpdateReservationPriceDto;
class BookingData {
}
exports.BookingData = BookingData;
class BookingDto extends BookingData {
}
exports.BookingDto = BookingDto;
class FindReservationsByOrganizationIdFiltersDto extends general_dto_1.PaginationQuery {
}
exports.FindReservationsByOrganizationIdFiltersDto = FindReservationsByOrganizationIdFiltersDto;
class ReservationTableOptionsDto extends general_dto_1.PaginationQuery {
}
exports.ReservationTableOptionsDto = ReservationTableOptionsDto;
class FindReservationsByUserIdFiltersDto extends general_dto_1.PaginationQuery {
}
exports.FindReservationsByUserIdFiltersDto = FindReservationsByUserIdFiltersDto;
class FindSlotsByFacilityIdFiltersDto {
    constructor() {
        this.limit = MAX_SLOTS_REQUEST_LIMIT;
    }
}
exports.FindSlotsByFacilityIdFiltersDto = FindSlotsByFacilityIdFiltersDto;
class IncludeConflictsOptionsDto {
}
exports.IncludeConflictsOptionsDto = IncludeConflictsOptionsDto;
class getSlotFQueryParamsDto {
}
exports.getSlotFQueryParamsDto = getSlotFQueryParamsDto;
class FindByReservationDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.FindByReservationDto = FindByReservationDto;
class GetFilterOptionsDto extends FindByReservationDto {
}
exports.GetFilterOptionsDto = GetFilterOptionsDto;
class DuplicateSlotDto extends FindByReservationDto {
}
exports.DuplicateSlotDto = DuplicateSlotDto;
class FindBySlotIdsDto extends SlotsFilterDto {
}
exports.FindBySlotIdsDto = FindBySlotIdsDto;
class UpdateReservationStatusDto extends FindByReservationDto {
}
exports.UpdateReservationStatusDto = UpdateReservationStatusDto;
class FindBySlotDto extends FindByReservationDto {
}
exports.FindBySlotDto = FindBySlotDto;
class EditItemsRefundMetaDto {
}
exports.EditItemsRefundMetaDto = EditItemsRefundMetaDto;
class EditReservationDetailsDto {
}
exports.EditReservationDetailsDto = EditReservationDetailsDto;
class RemoveSlotsFinancialDataDto {
}
exports.RemoveSlotsFinancialDataDto = RemoveSlotsFinancialDataDto;
class ReservationNotifyDto {
}
exports.ReservationNotifyDto = ReservationNotifyDto;
class UpdateReservationSlotsColorsDto {
}
exports.UpdateReservationSlotsColorsDto = UpdateReservationSlotsColorsDto;
class UpdateCustomerSlotsColorsDto {
}
exports.UpdateCustomerSlotsColorsDto = UpdateCustomerSlotsColorsDto;
class ChargeReservationResultDto extends purchase_dto_1.PurchaseResultDto {
}
exports.ChargeReservationResultDto = ChargeReservationResultDto;
class InvoiceReservationItemsDto extends invoice_dto_1.InvoiceCartDto {
}
exports.InvoiceReservationItemsDto = InvoiceReservationItemsDto;
class AddSegmentsDto extends invoice_dto_1.UpdateInvoiceDto {
}
exports.AddSegmentsDto = AddSegmentsDto;
class GetDraftReservationSlotsFiltersDto extends general_dto_1.PaginationQuery {
}
exports.GetDraftReservationSlotsFiltersDto = GetDraftReservationSlotsFiltersDto;
class ByDraftReservationIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByDraftReservationIdDto = ByDraftReservationIdDto;
class ByRentalProductId extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByRentalProductId = ByRentalProductId;
class SimpleDraftSegmentDto {
}
exports.SimpleDraftSegmentDto = SimpleDraftSegmentDto;
class DraftSlotsFilterResultDto {
}
exports.DraftSlotsFilterResultDto = DraftSlotsFilterResultDto;
class GetDraftReservationAddonsQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetDraftReservationAddonsQueryDto = GetDraftReservationAddonsQueryDto;
class GetDraftReservationOptionsDto {
}
exports.GetDraftReservationOptionsDto = GetDraftReservationOptionsDto;
class GetDraftSlotsOptions {
}
exports.GetDraftSlotsOptions = GetDraftSlotsOptions;
class DraftIdsDto extends GetDraftSlotsOptions {
}
exports.DraftIdsDto = DraftIdsDto;
class ByDraftSlotIdDto extends ByDraftReservationIdDto {
}
exports.ByDraftSlotIdDto = ByDraftSlotIdDto;
class GenerateReservationDto {
}
exports.GenerateReservationDto = GenerateReservationDto;
class UpdateDraftSlotsDto {
}
exports.UpdateDraftSlotsDto = UpdateDraftSlotsDto;
class SegmentsAddonsGroupDto extends BaseSegmentsAddonsGroupDto {
}
exports.SegmentsAddonsGroupDto = SegmentsAddonsGroupDto;
class ReservationAddonsDto {
}
exports.ReservationAddonsDto = ReservationAddonsDto;
class CreateReservationAddonsDto {
}
exports.CreateReservationAddonsDto = CreateReservationAddonsDto;
class ProblematicProductDto {
}
exports.ProblematicProductDto = ProblematicProductDto;
class PaginatedSlotsSharedDto {
}
exports.PaginatedSlotsSharedDto = PaginatedSlotsSharedDto;
class DuplicateReservationDto {
}
exports.DuplicateReservationDto = DuplicateReservationDto;
class DuplicateReservationItemsDto extends DuplicateReservationDto {
}
exports.DuplicateReservationItemsDto = DuplicateReservationItemsDto;
class ReservationItemLineDto {
}
exports.ReservationItemLineDto = ReservationItemLineDto;
class EditItemsRefundMetadataDto {
}
exports.EditItemsRefundMetadataDto = EditItemsRefundMetadataDto;
class EditSlotsFinancialDetailsDto {
}
exports.EditSlotsFinancialDetailsDto = EditSlotsFinancialDetailsDto;
class EditSlotsRefundMetadataDto {
}
exports.EditSlotsRefundMetadataDto = EditSlotsRefundMetadataDto;
class EditReservationItemsResultDto {
}
exports.EditReservationItemsResultDto = EditReservationItemsResultDto;
//# sourceMappingURL=reservation.dto.js.map